import type {
  CompleteOnboardingRequest,
  OnboardingAnswers,
  OnboardingProfile,
  OnboardingStatus,
  OnboardingStatusResponse,
} from '@/types/onboarding';

export const mapOnboardingProfile = (answers: OnboardingAnswers): OnboardingProfile => ({
  profession: answers.profession,
  ...(answers.profession_other !== undefined && { professionOther: answers.profession_other }),
  ...(answers.specialty !== undefined && { specialty: answers.specialty }),
  ...(answers.specialty_other !== undefined && { specialtyOther: answers.specialty_other }),
  consultationTypes: answers.consultation_types,
  sessionMode: answers.session_mode,
  noteDetail: answers.note_detail,
  noteFormat: answers.note_format,
  letterSignature: answers.letter_signature ?? null,
});

export const mapOnboardingStatus = (response: OnboardingStatusResponse): OnboardingStatus => ({
  required: response.required,
  completed: response.completed,
  answers: response.answers ? mapOnboardingProfile(response.answers) : null,
});

/** Optional keys are only sent when present, so the body matches the contract exactly. */
export const toCompleteOnboardingRequest = (profile: OnboardingProfile): CompleteOnboardingRequest => ({
  profession: profile.profession,
  ...(profile.professionOther !== undefined && { profession_other: profile.professionOther }),
  ...(profile.specialty !== undefined && { specialty: profile.specialty }),
  ...(profile.specialtyOther !== undefined && { specialty_other: profile.specialtyOther }),
  consultation_types: profile.consultationTypes,
  session_mode: profile.sessionMode,
  note_detail: profile.noteDetail,
  note_format: profile.noteFormat,
  ...(profile.letterSignature !== undefined && { letter_signature: profile.letterSignature }),
});
